// LLM generated - Model Claude 4 Sonnet
import { BRANDS, BRAND_NAMES } from '~/domains/auth/consts';
import { RYPRenderer } from '../renderers/RYPRenderer';
import { OFPRenderer } from '../renderers/OFPRenderer';
import { SplashRenderer } from '../renderers/SplashRenderer';

export type BrandConfig = {
  renderer: React.ComponentType<any>;
  supportsSSOHeader: boolean;
  getTranslationKey: () => string;
};

export const brandConfigs: Record<BRANDS, BrandConfig> = {
  [BRANDS.RYP]: {
    renderer: RYPRenderer,
    supportsSSOHeader: true,
    getTranslationKey: () => 'signIn.withAccount',
  },
  [BRANDS.OFP]: {
    renderer: OFPRenderer,
    supportsSSOHeader: false,
    getTranslationKey: () => 'signIn.withAccount',
  },
  [BRANDS.SPLASH]: {
    renderer: SplashRenderer,
    supportsSSOHeader: false,
    getTranslationKey: () => 'signIn.credentialsFrom',
  },
};

export function getBrandText(
  brand: BRANDS | undefined,
  t: (key: string, options?: any) => string
): string {
  const config = brandConfigs[brand || BRANDS.SPLASH];

  if (brand === BRANDS.SPLASH || !brand) {
    return t(config.getTranslationKey());
  }

  return t(config.getTranslationKey(), { brandName: BRAND_NAMES[brand] });
}
